module.exports = __webpack_public_path__ + "static/img/bg.a1398cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/friendDesc/bg.png
// module id = WD43
// module chunks = 0